export default {
  methods: {
    togglePermission(_items) {
      let selected = _.takeWhile(_items, ["permitted", true]);
      if (selected.length !== _items.length)
        _.forEach(_items, (itm) => {
          itm.permitted = true;
        });
      else
        _.forEach(_items, (itm) => {
          itm.permitted = false;
        });
    },

    getSelectedItems(_items) {
      return _items.filter((el) => el.permitted);
    },

    putItems(_this, _url, _items, _source, _successCallback, _errorCallback) {
      $.ajax({
        method: "PUT",
        url: _url,
        data: JSON.stringify(_items),
        dataType: "json",
        contentType: "application/json; charset=utf-8",

        success: () => {
          _successCallback();
        },
        error: (data) => {
          if (data.statusText == "OK") return;
          console.error("Error on PUT in " + _source + ".saveChanges()");
          _errorCallback();
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/policiesmixin.js